/* SignForm outcome events. No artwork, contact fields, URLs, prices or quote IDs
 * leave this module. Checkout and purchase stay with Shopify's native pixels. */
(() => {
  if (window.SignFormMeasure) return;
  const styles = new Set(['flat_cut','window_door_vinyl','business_hours','wall_logo_decal','acrylic_plaque','aluminum_plaque','vinyl_banner','a_frame','backlit_acrylic','blade_sign']);
  const names = new Set(['sign_page_viewed','preview_requested','preview_completed','manual_review_requested','revision_requested','revision_completed','cart_add_succeeded']);
  const memory = new Set();
  const storageKey = 'sf_measurement_seen_v1';
  let hydrated = false;
  function allowed() {
    try { return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed() === true; }
    catch (_) { return false; }
  }
  // Local deduplication fingerprint only; it is never an analytics field.
  function fingerprint(value) {
    let a = 2166136261, b = 5381;
    for (const c of String(value)) { a = Math.imul(a ^ c.charCodeAt(0), 16777619); b = Math.imul(b, 33) ^ c.charCodeAt(0); }
    return (a >>> 0).toString(36) + (b >>> 0).toString(36);
  }
  function referral() {
    let host = '';
    try { host = new URL(document.referrer).hostname.toLowerCase(); } catch (_) {}
    const providers = { 'chatgpt.com':'chatgpt', 'chat.openai.com':'chatgpt', 'perplexity.ai':'perplexity', 'gemini.google.com':'gemini', 'copilot.microsoft.com':'copilot', 'claude.ai':'claude' };
    if (providers[host]) return providers[host];
    if (host.endsWith('.perplexity.ai')) return 'perplexity';
    // Read only a known provider value; never forward query strings or arbitrary UTMs.
    try {
      const value = new URL(location.href).searchParams.get('utm_source')?.toLowerCase();
      if (value === 'chatgpt.com' || value === 'chatgpt') return 'chatgpt';
    } catch (_) {}
    return 'unidentified';
  }
  function track(name, data = {}, dedupeKey = '') {
    try {
      // Shopify attaches page context to custom events. Do not emit on private links.
      const params = new URL(location.href).searchParams;
      if (['lead_id','quote_id','sf_quote_token','public_token','token'].some(key => params.has(key))) return false;
      if (!names.has(name) || !allowed() || typeof window.Shopify?.analytics?.publish !== 'function') return false;
      if (!hydrated) {
        try { for (const k of JSON.parse(sessionStorage.getItem(storageKey) || '[]')) memory.add(k); } catch (_) {}
        hydrated = true;
      }
      const key = name + ':' + fingerprint(dedupeKey);
      if (dedupeKey && memory.has(key)) return false;
      const payload = { sign_type: styles.has(data.sign_style) ? data.sign_style : 'unspecified', source_mode: ['upload','text'].includes(data.sign_source) ? data.sign_source : 'unspecified', ai_referral: referral() };
      const result = window.Shopify.analytics.publish('signform:' + name, payload);
      if (result === false) return false;
      if (dedupeKey) {
        memory.add(key);
        try { sessionStorage.setItem(storageKey, JSON.stringify([...memory].slice(-300))); } catch (_) {}
      }
      // A rejected async publisher must never interrupt the configurator.
      if (result?.catch) result.catch(() => {});
      return true;
    } catch (_) { return false; }
  }
  window.SignFormMeasure = Object.freeze({ track });
  function pageView() {
    const root = document.querySelector('[data-lux-ai-sign]');
    if (!root) return;
    const signStyle = root.getAttribute('data-default-style');
    if (!styles.has(signStyle)) return;
    // One view per loaded document; request/completion dedupe persists in this tab.
    track('sign_page_viewed', { sign_style: signStyle }, 'document:' + document.documentElement.dataset.sfMeasureDocument);
  }
  document.documentElement.dataset.sfMeasureDocument = String(Date.now()) + Math.random().toString(36).slice(2);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', pageView, {once:true});
  else pageView();
  document.addEventListener('visitorConsentCollected', pageView);
})();
